import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, Alert, Stack } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../i18n/LanguageContext';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login({ username, password });
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.message || t('login.error'));
    } finally { setLoading(false); }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Paper sx={{ p: 4, maxWidth: 400, width: '100%' }}>
        <Typography variant="h4" align="center" gutterBottom>{t('login.title')}</Typography>
        <Typography variant="subtitle1" align="center" color="text.secondary" gutterBottom>{t('login.subtitle')}</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField fullWidth label={t('login.username')} value={username}
              onChange={e => setUsername(e.target.value)} disabled={loading} required />
            <TextField fullWidth label={t('login.password')} type="password" value={password}
              onChange={e => setPassword(e.target.value)} disabled={loading} required />
            <Button type="submit" variant="contained" fullWidth size="large" disabled={loading}>
              {loading ? t('common.loading') : t('login.submit')}
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
